
import React from 'react'

type UserRole = string | null

const UserRoleContext = React.createContext<UserRole>(null)

export default UserRoleContext
